// @flow
import * as React from 'react';
import Modal from 'react-modal';
import { withRouter } from 'app/context/Router.jsx';
import JoinGroupModal from 'groups/components/JoinGroupModal.jsx';
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';
import JoinConfirmSubscriptionModal from 'join/components/JoinConfirmSubscriptionModal.jsx';

type Props = {
  location: *,
  router: *,
};

type State = {
  code?: ?string,
};

class JoinGroupHandler extends React.Component<Props, State> {
  state: State = {};

  static getDerivedStateFromProps(nextProps: Props) {
    return {
      code: nextProps.location.query.code,
    };
  }

  clearStateCode = () => this.setState({ code: null });
  redirectToClasses = () => this.props.router.replace('/classes');
  redirectToClass = (g: *) => this.props.router.push(getRedirectLocationAfterGroupJoin(g));

  render() {
    const { code } = this.state;

    // prettier-ignore
    const modal = code
      ? <JoinConfirmSubscriptionModal code={code} onGroupNotFound={this.clearStateCode} onRequestHide={this.clearStateCode} />
      : <JoinGroupModal onJoin={this.redirectToClass} onRequestHide={this.redirectToClasses} />

    return (
      <Modal key="1" isOpen>
        {modal}
      </Modal>
    );
  }
}

export { JoinGroupHandler };
export default withRouter(JoinGroupHandler);
